import { render, staticRenderFns } from "./check-your-physical-fitness-2.vue?vue&type=template&id=8d8338c6&"
import script from "./check-your-physical-fitness-2.vue?vue&type=script&lang=js&"
export * from "./check-your-physical-fitness-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports